import Marionette from "../../../shared/marionette-mustache";
import { FullTextSourceModel } from "../../../desktop/models/full-text-source";
import { FullTextLinkRelationView } from "../../../desktop/views/partials/full-text-link-relation";
import { backboneViewProperties } from "../../../decorators/backbone-properties";

@backboneViewProperties({
    childView: FullTextLinkRelationView
})
export class FullTextLinksRelationsView extends Marionette.CollectionView<FullTextSourceModel, FullTextLinkRelationView> {
    constructor(options?: Marionette.CollectionViewOptions<FullTextSourceModel>) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/partials/full-text-links-relations.ts